import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Header from '../../../components/Editor/Header';
import { PdfImportingStatus } from '../constants';
import { isEditableSpread } from '../selectors';
import { getIsAccountManagerOrAdmin } from '../../ProfilePage/selectors';
import { getClientAndResourceIds } from '../utils/helpers';
import Utils from '../../../utils';
import DriveItemUtils from '../../../utils/driveItem';
import { Api } from '../../../typings/api';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList: { driveItems },
		galleryInfos: { template: { publicationSettings } },
		editor: {
			combo: { isCombining },
			settings: { pdfImportingStatus },
			preprodPublication: { isUpdating },
			themes,
			isAccessibleVersion,
		},
	} = state;
	const { originalGId, tempGId } = getClientAndResourceIds();
	const resource = driveItems[originalGId];
	const format = resource ? resource.format : undefined;
	const isEpubPreview = originalGId === tempGId && format === Api.PublicationFormat.EPUB_PREVIEW;

	return {
		isButtonEditDisplayed: isEditableSpread(state),
		isButtonSettingsDisplayed: getIsAccountManagerOrAdmin(state) && (
			DriveItemUtils.isModifiablePublication(format) && !!publicationSettings ||
			!!themes
		),
		isButtonPublishDisplayed: !isEpubPreview &&
			(Utils.isEmbedMode() ? !DriveItemUtils.isProposal(format) : true),
		shouldDisableButtons: isCombining ||
			pdfImportingStatus === PdfImportingStatus.PROCESSING ||
			isUpdating,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Header/index.tsx